import { get } from "lodash-es";
import React from "react";
import { ArchiveButton } from "./ArchiveButton";
import { FixNowButton } from "./FixNowButton";

export const DashboardActionsCell = ({ row }) => {
  const requestId = get(row.original, "pa_request.RequestId");
  const archived = get(row.original, "archived");
  const canFixNow = get(row.original, "user_actionable_mi", false);

  return (
    <>
      <ArchiveButton id={requestId} archived={archived} />
      {canFixNow && <FixNowButton id={requestId} className="me-1" />}
    </>
  );
};
